export enum CRMModalID {
    CRMModalDetails,
    CRMScopeDetails,
    CRMConfigurationDetails
}

export enum CRMConfigurationTemplateType {
    Desktop = 'Desktop',
    Cloud = 'Cloud'
}
